import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginationFilterRequest, PaginatedSelectModel } from "@/models/core.model";
import { StoryChapterMedia, StoryChapterMediaPaginationFilterRequest, UpsertStoryChapterMedia } from '@/models/story-chapter-media.model';

export const getPagedStoryChapterMedias = async (input: StoryChapterMediaPaginationFilterRequest): Promise<PagedResponseModel<StoryChapterMedia>> => {
  return await getReq(createUrl("a/Story/Chapter/Media/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getStoryChapterMediasLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedStoryChapterMedias(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.text
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getStoryChapterMedia = async (id: number): Promise<BaseResponseModel<StoryChapterMedia>> => {
  return await getReq(createUrl(`a/Story/Chapter/Media/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertStoryChapterMedia = async (input: UpsertStoryChapterMedia): Promise<BaseResponseModel<StoryChapterMedia>> => {
  return await postReq(createUrl("a/Story/Chapter/Media/Upsert"),
    input
  ).then((res: any) => res.data);
};
